/* Montrelio — ligne d'expédition de la fiche produit (26.09.2026).
   Réécrit [data-mbb-cutoff] selon l'heure de Paris :
   - jour ouvré avant 17 h : « Commandez dans 1 h 40 : préparée dès aujourd'hui. »
   - sinon : « Commandez maintenant : préparée dès demain. » (ou « dès lundi. »)
   Le texte de repli rendu par Liquid reste affiché si ce script ne tourne pas.
   Fichier externe (pas de <script> inline) : le morph d'Horizon ne ré-exécute pas
   les scripts inline. Rafraîchi toutes les 20 s et après chaque re-rendu du DOM. */
(function () {
  if (window.__mtrCutoff) return;
  window.__mtrCutoff = true;

  var CUTOFF_HOUR = 17;
  var fmt = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Paris', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
  });
  var DAYS = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 0 };

  function parisNow() {
    var parts = {};
    fmt.formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    return { day: DAYS[parts.weekday], minutes: parseInt(parts.hour, 10) * 60 + parseInt(parts.minute, 10) };
  }

  function label() {
    var now = parisNow();
    var isWorkday = now.day >= 1 && now.day <= 5;
    var left = CUTOFF_HOUR * 60 - now.minutes;
    if (isWorkday && left > 0) {
      var h = Math.floor(left / 60), m = left % 60;
      var d = h > 0 ? h + ' h ' + (m < 10 ? '0' : '') + m : m + ' min';
      return 'Commandez dans <b>' + d + '</b> : préparée dès aujourd’hui.';
    }
    /* Prochain jour ouvré : demain du lundi au jeudi soir, lundi sinon. */
    var nextIsTomorrow = now.day >= 1 && now.day <= 4;
    return 'Commandez maintenant : préparée dès ' + (nextIsTomorrow ? 'demain' : 'lundi') + '.';
  }

  function update() {
    var nodes = document.querySelectorAll('[data-mbb-cutoff]');
    if (!nodes.length) return;
    var html = label();
    var text = html.replace(/<[^>]+>/g, '');
    for (var i = 0; i < nodes.length; i++) {
      /* Comparaison sur le texte visible, jamais sur innerHTML (qui re-sérialise les
         espaces insécables en &nbsp; : la boucle avec l'observer serait infinie). */
      if (nodes[i].textContent !== text) nodes[i].innerHTML = html;
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update);
  else update();
  setInterval(update, 20000);

  /* Re-rendu de la buy-box (changement de variante) : on réapplique aussitôt,
     regroupé sur une frame pour rester négligeable. */
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; update(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
